// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M14 7H21V8L14 11V7ZM14 7H10M14 7V15M10 11L3 8V7H10M10 11V7M10 11L10 18M10 11L14 15M14 18H15L16 22H8L9 18H10M14 18H10M14 18V15M11 2H13V4H11V2Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"statue-of-jesus"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14 18H15L16 22H8L9 18H10H14Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 7H21V8L14 11V7ZM14 7H10M14 7V15M10 11L3 8V7H10M10 11V7M10 11L10 18M10 11L14 15M14 18H15L16 22H8L9 18H10M14 18H10M14 18V15M11 2H13V4H11V2Z","strokeWidth":"props.strokeWidth"}}]}]};

const StatueOfJesusIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'statue-of-jesus',
    ref,
    icon: element,
  },
));

StatueOfJesusIcon.displayName = 'StatueOfJesusIcon';

export default StatueOfJesusIcon;
